module.exports = __webpack_public_path__ + "img/HR.3ce9b5e0.svg";